import { openWithSession } from '@laramie/ui'
import { APPCONFIG } from "../app.config"
import { APIS } from "../config/apis"

export const openTempView = (url, options) => {
    const params = '?tempView=true'

    // La sesión va con un código de un solo uso, nunca con el token en la dirección.
    if (options?.addAuth) {
        openWithSession(APIS.URLS.SESION, APPCONFIG.SITE.WEBAPP + 'unauthorized', url + params)
        return
    }

    window.open(url + params)
}
